export = {
  statsInit: {
    aces: 0,
    max_points_in_a_row: 0,
    points_won: 0,
    service_errors: 0,
    timeouts: 0,
    service_points_success: 0,
    service_points_total: 0,
    service_points_rate: 0,
    receiver_points_success: 0,
    receiver_points_total: 0,
    receiver_points_rate: 0,
  },
  techKind: {
    points_won: "Tổng điểm",
    service_points_success: "Ghi điểm khi giao bóng",
    service_points_rate: "Tỉ lệ ghi điểm khi giao bóng",
    receiver_points_success: "Ghi điểm khi nhận bóng",
    receiver_points_rate: "Tỉ lệ ghi điểm khi nhận bóng",
    aces: "Cú giao bóng ăn điểm trực tiếp",
    service_errors: "Lỗi phát bóng",
    max_points_in_a_row: "Dành điểm liên tục nhiều nhất",
    timeouts: "Số lần hội ý",
  },
  percentKeys: ["service_points_rate", "receiver_points_rate"],
  showPreKeys: ["service_points_success", "receiver_points_success"],
};
